import { render, staticRenderFns } from "./ArticleKeywordTag.vue?vue&type=template&id=e5ab368a&scoped=true"
import script from "./ArticleKeywordTag.vue?vue&type=script&lang=js"
export * from "./ArticleKeywordTag.vue?vue&type=script&lang=js"
import style0 from "./ArticleKeywordTag.vue?vue&type=style&index=0&id=e5ab368a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ab368a",
  null
  
)

export default component.exports